import get from 'lodash/get';

export function getError(locale, data) {
  const code = get(data, '0.code');
  const userMessage = get(data, '0.userMessage');
  return locale[code] || userMessage || locale['common.server.error'];
}

export const handleError = (locale, callback) => (data) => callback(getError(locale, data));
export default handleError;
